import React from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';

const allowClearConfig = {
  clearIcon: <AiOutlineCloseCircle className="h-4 w-4 text-blue-900" />,
};

export default allowClearConfig;
